import App from './App'
// import messages from './locale/index'
import loadLocaleMessages from './locale/index'

import uviewPlus from 'uview-plus'
import 'uno.css'

import { createPinia } from "pinia";

import KPage from './components/iteration/KPage.vue'
import KInput from './components/iteration/KInput.vue'
import KPickup from './components/iteration/KPickup.vue'
import KPopup from './components/iteration/KPopup.vue'
import KModal from './components/iteration/KModal.vue'

let i18nConfig = {
  locale: uni.getStorageSync('lang') || 'th', // 默认中文
  messages: loadLocaleMessages()
}

// #ifndef VUE3
import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
Vue.use(uviewPlus)
const i18n = new VueI18n(i18nConfig)
Vue.config.productionTip = false
App.mpType = 'app'
const app = new Vue({
  i18n,
  ...App
})
app.$mount()
// #endif

// #ifdef VUE3
import { createSSRApp } from 'vue'
import { createI18n } from 'vue-i18n'
const i18n = createI18n(i18nConfig)
export function createApp() {
  const app = createSSRApp(App)

  app.use(createPinia());

  app.use(i18n)
  app.use(uviewPlus)

  app.component('k-page', KPage)
  app.component('k-input', KInput)
  app.component('k-pickup', KPickup)
  app.component('k-popup', KPopup)
  app.component('k-modal', KModal)
  return {
    app
  }
}
// #endif
